<template>
    <div class="hstack gap-1 h-100">
        <label v-if="label != ''">{{ label }}</label>
        <Datepicker
            ref="datePicker"
            :model-value="modelValue"
            :format="dateFormat"
            :enable-time-picker="false"
            :utc="true"
            :clearable="true"
            :required="true"
            :input-class-name="'form-control h-100'"
            auto-apply
            :enterSubmit="true"
            @update:model-value="handleUpdate($event)">
        </Datepicker>
    </div>
</template>
<script setup lang="ts">
import {defineComponent, watch, ref} from "vue";
import type {PropType} from "vue";
import Datepicker from "@vuepic/vue-datepicker";
import {BFilter} from "@/components/BFilterEditor/BFilterEditor.types";

const props = defineProps<{
    items: BFilter[];
    disabled: boolean;
    modelValue: string;
    label: string;
}>();

var datePicker = ref<any | null>(null);
const filterValue = ref(props.modelValue ?? "");
const dateFormat = "yyyy-MM-dd";

const emit = defineEmits<{
    (event: "update:modelValue", value: string): void;
}>();

function handleUpdate(event:any){            
    emit('update:modelValue', event);
    
    if(datePicker.value != null){
        datePicker.value.focus();
    }
}
</script>
